import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule,
         MatButtonModule,
         MatButtonToggleModule,
         MatCardModule,
         MatCheckboxModule,
         MatChipsModule,
         MatDatepickerModule,
         MatDialogModule,
         MatExpansionModule,
         MatGridListModule,
         MatIconModule,
         MatInputModule,
         MatListModule,
         MatMenuModule,
         MatNativeDateModule,
         MatPaginatorModule,
         MatProgressBarModule,
         MatProgressSpinnerModule,
         MatRadioModule,
         MatRippleModule,
         MatSelectModule,
         MatSidenavModule,
         MatSliderModule,
         MatSlideToggleModule,
         MatSnackBarModule,
         MatSortModule,
         MatTableModule,
         MatTabsModule,
         MatToolbarModule,
         MatTooltipModule,
         MatStepperModule } from '@angular/material';

//import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
//import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
//import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
//const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
//  wheelPropagation: true,
//  suppressScrollX: true               
//};

import { PipesModule } from '../theme/pipes/pipes.module';
//import { RatingComponent } from './rating/rating.component';
import { ControlsComponent } from './controls/controls.component';
import { MainCarouselComponent } from './main-carousel/main-carousel.component';
//import { BrandsCarouselComponent } from './brands-carousel/brands-carousel.component';
import { NewProductsCarouselComponent } from './products-carousel/new-products-carousel.component';
import { DiscountProductsCarouselComponent } from './products-carousel/discount-products-carousel.component';
import { DownloadAppComponent } from './downloadApp/downloadApp.component';
import { RestorePasswordComponent } from '../sign-in/restorePassword/restorePassword.component';
import { AddDiscountComponent } from '../cart/addDiscount/addDiscount.component';
import { ProductDialogComponent } from './products-carousel/product-dialog/product-dialog.component';
import { CategoryBannersComponent } from './categoryBanners/categoryBanners.component';
import { CategoryListComponent } from './category-list/category-list.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SwiperModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
  //  PerfectScrollbarModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    RouterModule,
    SwiperModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    //PerfectScrollbarModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    //RatingComponent,
    ControlsComponent,
    MainCarouselComponent,
    //BrandsCarouselComponent,
    NewProductsCarouselComponent,
    DiscountProductsCarouselComponent,
    DownloadAppComponent,
    RestorePasswordComponent,
    ProductDialogComponent,
    AddDiscountComponent,
    CategoryBannersComponent,
    CategoryListComponent
  ],
  declarations: [
    //RatingComponent,
    ControlsComponent,
    MainCarouselComponent,
    //BrandsCarouselComponent,
    NewProductsCarouselComponent,
    DiscountProductsCarouselComponent,
    DownloadAppComponent,
    RestorePasswordComponent,
    ProductDialogComponent,
    AddDiscountComponent,
    CategoryBannersComponent,
    CategoryListComponent
  ],
  entryComponents: [
    DownloadAppComponent,
    RestorePasswordComponent,
    ProductDialogComponent,
    AddDiscountComponent
  ],
  providers:[
    //{ provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG }
  ]
})
export class SharedModule { }
